import React from 'react';
import { useLocation } from 'react-router-dom';
import languages, { languageList } from "assets/lang/lang";
import { getFirstUrlParameter } from "tools/tools";
var initial = languages[0];
export var ProvideLangContext = React.createContext(initial);
function LangProvider(_a) {
    var children = _a.children;
    var location = useLocation();
    var value = function () {
        var firstParameter = getFirstUrlParameter(location.pathname);
        var lang = '';
        var value = initial;
        if (firstParameter) {
            lang = languageList.find(function (item) { return item === firstParameter; });
        }
        if (lang) {
            value = languages.find(function (item) { return item.lang === lang; });
        }
        else {
            value = languages.find(function (item) { return item.default; });
        }
        return value;
    };
    return (React.createElement(ProvideLangContext.Provider, { value: value() }, children));
}
export default LangProvider;
